import type {ElementConfig} from '@pinecast/common/types';
import {useCSS} from '@pinecast/styles';
import * as React from 'react';

import TopHeader from './TopHeader';

const Chrome = ({
  children,
  returnLink,
  standalonePage,
}: {
  children: React.ReactNode;
  returnLink?: ElementConfig<typeof TopHeader>['returnLink'];
  standalonePage?: boolean;
}) => {
  const css = useCSS();
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        paddingLeft: '12px',
        paddingRight: '12px',
      })}
    >
      <TopHeader returnLink={returnLink} />
      <div
        className={css({
          flex: '1 1',
          maxWidth: standalonePage ? '700px' : undefined,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default Chrome;
